import React, { useState, useEffect } from "react";
import TCInvoicingTab from "./InvoiceTabs/TCInvoicingTab";
import CCInvoicingTab from "./InvoiceTabs/CCInvoicingTab";
import apiClient from "../../../../../../Config/apiClient";
import Loader from "../../../../../../Context/Loader/Loader";
import { showSuccessToast, showErrorToast } from "../../../../../../Context/Toaster/Toaster";

const invoiceSettingsPath = process.env.REACT_APP_HS_INVOICE_SETTINGS_BASE_PATH;
const isDailyInvoicingEnabled = process.env.REACT_APP_ENABLE_DAILY_INVOICING === "true";

const InvoiceSettings = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [tcSettings, setTcSettings] = useState({
    invoice_frequency: "",
    invoice_due: "",
    invoice_commission: "",
    invoice_tax_percent: 13,
  });

  const [ccSettings, setCcSettings] = useState({
    invoice_frequency: "",
    invoice_due: "",
    invoice_tax_percent: 13,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);

        const [tcRes, ccRes] = await Promise.all([
          apiClient.get(`${invoiceSettingsPath}/get-tc`),
          apiClient.get(`${invoiceSettingsPath}/get-cc`),
        ]);

        if (tcRes.data.status === "SUCCESS") {
          setTcSettings({
            ...tcRes.data.data,
            invoice_tax_percent: tcRes.data.data?.invoice_tax_percent ?? 13,
          });
        }
        if (ccRes.data.status === "SUCCESS") {
          setCcSettings({
            ...ccRes.data.data,
            invoice_tax_percent: ccRes.data.data?.invoice_tax_percent ?? 13,
          });
        }
      } catch (error) {
        showErrorToast("Failed to fetch invoice settings");
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);

      if (activeTab === "tab1") {
        const res = await apiClient.put(`${invoiceSettingsPath}/update-tc`, tcSettings);
        if (res.data.status === "SUCCESS") {
          showSuccessToast("TC invoice settings updated successfully!");
          setTcSettings(res.data.data);
        }
      } else {
        const res = await apiClient.put(`${invoiceSettingsPath}/update-cc`, ccSettings);
        if (res.data.status === "SUCCESS") {
          showSuccessToast("CC invoice settings updated successfully!");
          setCcSettings(res.data.data);
        }
      }
    } catch (error) {
      showErrorToast("Failed to update invoice settings");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="report-wraper">
      <div className="tab-content" id="myTabContent">
        <div className="tab-pane fade show active" id="start" role="tabpanel" aria-labelledby="start-tab">
          <div className="report-tabinner">
            <div className="reportform-cover mt-0">
              <div className="row">
                <div className="col-md-12 inner-tab-container">
                  <div className="aptab-header mb-3">
                    <ul className="nav nav-tabs innertab-list" id="myTab" role="tablist">
                      {[
                        { id: "tab1", label: "TC Invoicing" },
                        { id: "tab2", label: "CC Invoicing" },
                      ].map(({ id, label }) => (
                        <li className="nav-item" role="presentation" key={id}>
                          <button className={`nav-link tab-btn ${activeTab === id ? "active" : ""}`} onClick={() => setActiveTab(id)} >
                            {label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="aptab-body">
                    {loading ? (
                      <div className="text-center"><Loader /></div>
                    ) : (
                      <>
                        {activeTab === "tab1" && (
                          <TCInvoicingTab
                            settings={tcSettings}
                            setSettings={setTcSettings}
                            showDailyOption={isDailyInvoicingEnabled}
                          />
                        )}
                        {activeTab === "tab2" && (
                          <CCInvoicingTab
                            settings={ccSettings}
                            setSettings={setCcSettings}
                            showDailyOption={isDailyInvoicingEnabled}
                          />
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="row mt-3" style={{ marginBottom: '30px' }}>
                <div className="col-md-12">
                  <button className="cp-button generate-button" onClick={handleSave} disabled={saving} >
                    {saving ? <Loader /> : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSettings;